<template>
  <div class="page-class page-home">
    <b-container class="text-center my-5">
      <h1>TokenSystems</h1>
      <p class="lead">Hier erhalten Sie die Übersicht über Ihre Assets</p>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  metaInfo: {
    title: 'Home',
    meta: [
      {
        name: 'description',
        content: 'Welcome to the backend.'
      }
    ]
  }
};
</script>
